import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../../../backend/firebaseConfig";

const helpfulContactsDocument = () => doc(db, "Recruitment", "HelpfulContacts");

export const getHelpfulContacts = async () => {
  const snapshot = await getDoc(helpfulContactsDocument());
  if (!snapshot.exists()) return null;
  return Array.isArray(snapshot.data()?.helpfulContacts)
    ? snapshot.data().helpfulContacts
    : [];
};

export const saveHelpfulContacts = async (helpfulContacts, updatedBy) => {
  await setDoc(
    helpfulContactsDocument(),
    {
      helpfulContacts,
      helpfulContactsUpdatedAt: serverTimestamp(),
      helpfulContactsUpdatedBy: updatedBy || null,
    },
    { merge: true },
  );
};
